import { Link, useParams } from "react-router-dom";
import { AppearanceMenu } from "@/components/AppearanceMenu";
import { Logo } from "@/components/Logo";
import { LegalLinks } from "@/components/LegalLinks";
import { POLICIES, POLICY_UPDATED } from "@/lib/policies";

export default function Policy() {
  const { slug } = useParams();
  const p = POLICIES[slug];
  return (
    <div data-testid="policy-page" className="min-h-screen bg-canvas">
      <header className="border-b border-line bg-surface">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3 sm:px-6"><Logo className="h-9" /><div className="flex items-center gap-3"><AppearanceMenu /><Link to="/pricing" data-testid="policy-pricing-link" className="text-sm font-semibold text-ink hover:underline">Plans</Link></div></div>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-14 sm:px-6">
        {!p ? <p data-testid="policy-not-found" className="text-ink-2">Page not found.</p> : (
          <>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-aqua">Legal</p>
            <h1 data-testid="policy-title" className="mt-3 text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">{p.title}</h1>
            <p className="mt-3 text-sm text-ink-3">Last updated {POLICY_UPDATED}</p>
            <div className="mt-10 grid gap-8">
              {p.sections.map(([h, t], i) => (
                <section key={h} data-testid={`policy-section-${i}`}>
                  <h2 className="font-display text-base font-bold text-ink md:text-lg">{i + 1}. {h}</h2>
                  <p className="mt-2 leading-relaxed text-ink-2">{t}</p>
                </section>
              ))}
            </div>
          </>
        )}
      </main>
      <footer className="border-t border-line py-6"><div className="mx-auto max-w-4xl px-4 sm:px-6"><LegalLinks /></div></footer>
    </div>
  );
}
